import "./Home.module.css";
import PracticeAreas from "./sections/PracticeAreas";
import CallToAction from "./sections/CallToAction";
import Professionallawhero from "./sections/Professionallawhero";
import Mainheader from "./sections/Mainheader";
import Footer from "@/reusable_sections/Footer";
import Leadership from "./sections/Leadership";
import Media from "./sections/Media";
import Philosophy from "./sections/Philosophy";
import Ourstorypreview from "./sections/Ourstorypreview";
export default function HomePage() {
  return <div>
      <Mainheader />
      <Professionallawhero />
      <PracticeAreas />
      <Leadership />
      <Philosophy />
      <Media />
      <Ourstorypreview />
      <CallToAction />
      <Footer />
    </div>;
}